export const doNothing = () => ''



// WEBPACK FOOTER //
// ./src/utils/doNothing.ts